
const Network = () => {
  return (
    <section id="rede" className="content-section">
      <div className="card mb-3">
        <div className="card-body text-center">
          <h5 className="card-title">Rede</h5>
        </div>
        <div className="card">
          <div className="fw-bold">Modo de operação</div>
          <p className="justified-text">
            Permite definir o comportamento do equipamento na rede.
          </p>
          <img
            src="./res/figures/modo-operacao.png"
            className="card-img-bottom img-lg"
            alt=""
          />
          <ul className="p-xss-0 p-md-3 justified-text">
            <li>
              <p className="mb-0">
                <strong>Nome do equipamento: </strong>nome/apelido que pode ser
                configurado para cada equipamento na rede, com o intuito de
                facilitar sua identificação.
              </p>
            </li>
            <li>
              <p className="mb-0">
                <strong>Modo de operação:</strong>
              </p>
              <p className="mb-0">
                <strong className="text-muted">Bridge: </strong>o equipamento
                opera como uma ponte entre os clientes conectados e as
                interfaces externas, mantendo a comunicação na mesma rede.
              </p>
              <p className="mb-0">
                <strong className="text-muted">Roteador: </strong> o equipamento
                faz o roteamento entre os clientes conectados e as interfaces
                externas, gerando uma sub-rede para os clientes conectados.
              </p>
            </li>
            <li>
              <p className="mb-0">
                <strong>Habilitar NAT: </strong>habilita a operação do NAT na
                interface de rede do produto.
              </p>
            </li>
          </ul>
          <br />

          <div>
            <div id="wan" className="fw-bold">
              WAN
            </div>
            <p className="justified-text mb-0">
              Permite configurar parâmetros relacionados à conexão do
              equipamento com a internet (WAN).
            </p>
            <p className="justified-text">
              <strong>Obs.: </strong>essa funcionalidade está disponível apenas
              quando o modo de operação for Roteador.
            </p>

            <p className="mb-0 text-muted">IPv4</p>
            <p className="mb-0">
              <strong>Tipo de configuração: </strong>
            </p>

            <p className="mb-0">
              <strong>PPPoE: </strong>escolha PPPoE para conectar ao seu provedor de acesso via PPPoE.
            </p>

            <div className="d-flex justify-content-center img-container">
              <img
                src="./res/figures/wan-ppoe.png"
                className="card-img-bottom img-xl"
                alt=""
              />
            </div>

            <ul className="p-xss-0 p-md-3 justified-text pt-0">
              <li>
                <p className="mb-0 justified-text">
                  <strong>MPPE: </strong>habilita criptografia MPPE (Microsoft Point-to-Point Encryption).
                </p>
              </li>
              <li>
                <p className="mb-0 justified-text">
                  <strong>Nome do serviço: </strong>nome do serviço PPPoE de seu provedor.
                </p>
              </li>
              <li>
                <p className="mb-0 justified-text">
                  <strong>Usuário PPPoE: </strong>define o nome do usuário para autenticação PPPoE.
                </p>
              </li>
              <li>
                <p className="mb-0 justified-text">
                  <strong>Senha: </strong>define a senha para autenticação PPPoE.
                </p>
              </li>
            </ul>


            <p className="mb-0">
              <strong>IP estático: </strong>define as configurações de IP
              manualmente.
            </p>

            <div className="d-flex justify-content-center img-container">
              <img
                src="./res/figures/wan-ip-estatico.png"
                className="card-img-bottom img-xl"
                alt=""
              />
            </div>

            <ul className="p-xss-0 p-md-3 justified-text pt-0">
              <li>
                <p className="mb-0 justified-text">
                  <strong>Clonar MAC: </strong>define um endereço MAC a ser
                  clonado. Alguns provedores restringem o acesso a um endereço
                  MAC previamente detectado por outro equipamento. Assim sendo,
                  você deve notificar seu provedor quanto à troca de MAC ou
                  simplesmente clonar o MAC do equipamento anterior.
                </p>
              </li>
              <li>
                <p className="mb-0 justified-text">
                  <strong>Endereço IPv4: </strong>define o endereço IP da
                  interface.
                </p>
              </li>
              <li>
                <p className="mb-0 justified-text">
                  <strong>Máscara de Sub-rede: </strong>define a máscara de
                  sub-rede da interface.
                </p>
              </li>
              <li>
                <p className="mb-0 justified-text">
                  <strong>Gateway: </strong>define o gateway-padrão da
                  interface.
                </p>
              </li>
              <li>
                <p className="mb-0 justified-text">
                  <strong>MTU (Maximum Transmission Unit): </strong>é o tamanho
                  máximo do pacote que a interface pode transmitir.
                </p>
              </li>
              <li>
                <p className="mb-0 justified-text">
                  <strong>VLAN: </strong>possibilita acessar a interface WAN a
                  partir de uma rede virtual local, atribuindo um VLAN ID para
                  esta interface.
                </p>
              </li>
              <li>
                <p className="mb-0 justified-text">
                  <strong>Cliente DHCP: </strong>define a WAN para receber um
                  endereço IP automaticamente por um servidor DHCP.
                </p>
                <div className="d-flex justify-content-center img-container">
                  <img
                    src="./res/figures/wan-cliente-dhcp.png"
                    className="card-img-bottom img-xl"
                    alt=""
                  />
                </div>
              </li>
            </ul>

            <p className="mb-0 text-muted">IPv6</p>
            <p className="mb-0">
              <strong>Tipo de configuração: </strong>
            </p>
            <ul className="p-xss-0 p-md-3 justified-text pt-0">
              <li>
                <p className="mb-0 justified-text">
                  <strong>Desabilitado: </strong>desabilitar o endereço IPv6 no
                  equipamento.
                </p>
                <div className="d-flex justify-content-center img-container">
                  <img
                    src="./res/figures/wan-ipv6-desativado.png"
                    className="card-img-bottom img-xl"
                    alt=""
                  />
                </div>
              </li>
              <li>
                <p className="mb-0 justified-text">
                  <strong>IP Estático: </strong>o endereço do IPv6 deve ser
                  especificado manualmente.
                </p>
                <div className="d-flex justify-content-center img-container">
                  <img
                    src="./res/figures/wan-ipv6.png"
                    className="card-img-bottom img-xl"
                    alt=""
                  />
                </div>
              </li>
              <li>
                <ul className="p-xss-0 p-md-3 justified-text pt-0">
                  <li>
                    <p className="mb-0 justified-text">
                      <strong>Endereço IP: </strong>especifica o endereço IPv6
                      para a interface.
                    </p>
                  </li>
                  <li>
                    <p className="mb-0 justified-text">
                      <strong>Tamanho do prefixo: </strong>insere o comprimento
                      do prefixo IPv6 para o endereço.
                    </p>
                  </li>
                  <li>
                    <p className="mb-0 justified-text">
                      <strong>Gateway: </strong>especifica o endereço do IPv6
                      para o gateway padrão.
                    </p>
                  </li>
                </ul>
              </li>
              <li>
                <p className="mb-0 justified-text">
                  <strong>Automático: </strong>IP gerado automaticamente pelo
                  produto. Pode operar no modo Stateless ou Stateful.
                </p>
                <div className="d-flex justify-content-center img-container">
                  <img
                    src="./res/figures/wan-ipv6-auto.png"
                    className="card-img-bottom img-xl"
                    alt=""
                  />
                </div>
              </li>
              <li>
                <p className="mb-0 justified-text">
                  <strong>Link local: </strong>IP gerado automaticamente pelo
                  produto.
                </p>
                <div className="d-flex justify-content-center img-container">
                  <img
                    src="./res/figures/wan-ipv6-link-local.png"
                    className="card-img-bottom img-xl"
                    alt=""
                  />
                </div>
              </li>
            </ul>
          </div>

          <div>
            <div id="lan" className="fw-bold">
              LAN
            </div>
            <p className="justified-text">
              Permite configurar parâmetros relacionados à conexão do
              equipamento com a rede local (LAN).
            </p>
            <p className="mb-0 justified-text">
              Caso seu equipamento esteja em modo de operação Bridge, a seguinte
              tela será apresentada.
            </p>
            <p className="mb-0 text-muted">IPv4</p>
            <div className="d-flex justify-content-center">
              <img
                src="./res/figures/lan-ipv4-bridge.png"
                className="card-img-bottom img-xl"
                alt=""
              />
            </div>
            <ul className="p-xss-0 p-md-3 justified-text pt-0">
              <li>
                <p className="mb-0 justified-text">
                  <strong>Endereço IP dinâmico (automático): </strong>marque
                  para obter endereço de um servidor DHCP.
                </p>
              </li>
              <li>
                <p className="mb-0 justified-text">
                  <strong>Endereço de IP Fixo / Fallback: </strong>endereço a
                  ser atribuído, caso o equipamento não receba corretamente o
                  endereçamento, através do servidor DHCP.
                </p>
              </li>
              <li>
                <p className="mb-0 justified-text">
                  <strong>Máscara de Sub-rede: </strong>máscara de sub-rede do
                  equipamento.
                </p>
              </li>
              <li>
                <p className="justified-text">
                  <strong>Gateway Padrão: </strong>define o gateway-padrão da
                  interface.
                </p>
              </li>
            </ul>

            <p className="mb-0 justified-text">
              Para equipamentos configurados em modo de operação Roteador, a
              seguinte tela será apresentada.
            </p>
            <div className="d-flex justify-content-center">
              <img
                src="./res/figures/lan-ipv4-roteador.png"
                className="card-img-bottom img-xl"
                alt=""
              />
            </div>
            <ul className="p-xss-0 p-md-3 justified-text pt-0">
              <li>
                <p className="mb-0 justified-text">
                  <strong>Endereço de IP Fixo / Fallback: </strong>endereço a
                  ser atribuído, caso o equipamento não receba corretamente o
                  endereçamento, através do servidor DHCP.
                </p>
              </li>
              <li>
                <p className="mb-0 justified-text">
                  <strong>Máscara de Sub-rede: </strong>máscara de sub-rede do
                  equipamento.
                </p>
              </li>
            </ul>

            <p className="mb-0 text-muted">IPv6</p>
            <ul className="p-xss-0 p-md-3 justified-text pt-0">
              <li>
                <p className="mb-0">
                  <strong>Tipo de configuração: </strong>
                </p>
              </li>
              <li>
                <p className="mb-0 justified-text">
                  <strong>Automático: </strong>IP gerado automaticamente pelo
                  produto. Pode operar no modo Stateless ou Stateful.
                </p>
                <div className="d-flex justify-content-center img-container">
                  <img
                    src="./res/figures/lan-ipv6-auto.png"
                    className="card-img-bottom img-xl"
                    alt=""
                  />
                </div>
              </li>
              <li>
                <p className="mb-0 justified-text">
                  <strong>Desabilitado: </strong>desabilitar o endereço IPv6 no
                  equipamento.
                </p>
                <div className="d-flex justify-content-center img-container">
                  <img
                    src="./res/figures/lan-ipv6-desativado.png"
                    className="card-img-bottom img-xl"
                    alt=""
                  />
                </div>
              </li>
              <li>
                <p className="mb-0 justified-text">
                  <strong>Link local: </strong>IP gerado automaticamente pelo
                  produto.
                </p>
                <div className="d-flex justify-content-center img-container">
                  <img
                    src="./res/figures/lan-ipv6-link-local.png"
                    className="card-img-bottom img-xl"
                    alt=""
                  />
                </div>
              </li>
              <li>
                <p className="mb-0 justified-text">
                  <strong>Manual: </strong>o endereço do IPv6 deve ser
                  especificado manualmente.
                </p>
                <div className="d-flex justify-content-center img-container">
                  <img
                    src="./res/figures/lan-ipv6.png"
                    className="card-img-bottom img-xl"
                    alt=""
                  />
                </div>
              </li>
              <ul className="p-xss-0 p-md-3 justified-text pt-0">
                <li>
                  <p className="mb-0 justified-text">
                    <strong>Endereço IP: </strong>especifica o endereço IPv6
                    para a interface.
                  </p>
                </li>
                <li>
                  <p className="mb-0 justified-text">
                    <strong>Tamanho do Prefixo: </strong>insere o comprimento do
                    prefixo IPv6 para o endereço.
                  </p>
                </li>
                <li>
                  <p className="mb-0 justified-text">
                    <strong>Gateway Padrão: </strong>especifica o endereço do
                    IPv6 para o gateway padrão. <strong>Obs.: </strong>
                    disponível somente para o modo bridge.
                  </p>
                </li>
              </ul>
            </ul>
          </div>

          <div>
            <div id="dhcp" className="fw-bold">
              DHCP
            </div>
            <p className="mb-0 justified-text">
              Permite configurar um servidor DHCP na sua rede, como também
              definir um IP estático.
            </p>

            <div className="d-flex justify-content-center">
              <img
                src="./res/figures/dhcp.png"
                className="card-img-bottom img-xl"
                alt=""
              />
            </div>

            <ul className="p-xss-0 p-md-3 justified-text pt-0">
              <li>
                <p className="mb-0 justified-text">
                  <strong>Habilitar DHCP: </strong>permite habilitar ou
                  desabilitar o servidor DHCP.
                </p>
              </li>
              <li>
                <p className="mb-0 justified-text">
                  <strong>Proteção contra ataque de DNS Rebind: </strong>permite
                  desativar DNS Rebind.
                </p>
              </li>
              <li>
                <p className="mb-0 justified-text">
                  <strong>Endereço IP Inicial: </strong>permite definir o IP
                  inicial do intervalo dos possíveis endereços IP da rede.
                </p>
              </li>
              <li>
                <p className="mb-0 justified-text">
                  <strong>Endereço IP Final: </strong>permite definir o IP final
                  do intervalo dos possíveis endereços IP da rede.
                </p>
              </li>
              <li>
                <p className="mb-0 justified-text">
                  <strong>Tempo de Renovação: </strong>controla o tempo de
                  renovação dos endereços, indicando o tempo em que o servidor
                  verifica se os clientes estão ativos.
                </p>
              </li>
            </ul>

            <p className="mb-0 justified-text">
              <strong>Obs.: </strong>ao desabilitar esta função você pode ser
              vítima de ataques, do tipo spam, ataques distribuídos de negação
              de serviço (DDoS) e outras atividades maliciosas.
            </p>

            <div>
              <p className="mb-0 justified-text">
                <strong>Configurando um IP estático na rede:</strong>
              </p>
              <ul className="p-xss-0 p-md-3 justified-text pt-0">
                <li>
                  <p className="mb-0 justified-text">Clique em Adicionar.</p>
                </li>
                <li>
                  <p className="mb-0 justified-text">
                    Preencha as informações do equipamento: IP, MAC e Descrição.
                  </p>
                </li>
                <li>
                  <p className="mb-0 justified-text">Clique em Adicionar.</p>
                </li>
              </ul>
              <p className="mb-0 justified-text">
                <strong>Obs.: </strong>a quantidade máxima de IPs estáticos
                possíveis é igual a quantidade de IPs configurados na opção
                Intervalo do Servidor DHCP.
              </p>
            </div>
          </div>

          <div>
            <div id="dns" className="fw-bold">
              DNS
            </div>

            <p className="justified-text">
              Permite selecionar se os endereços dos servidores DNS serão
              definidos automaticamente ou manualmente.
            </p>

            <p className="mb-0 text-muted">IPv4</p>

            <ul className="p-xss-0 p-md-3 justified-text pt-0">
              <li>
                <p className="mb-0 justified-text">
                  <strong>Modo DNS:</strong>
                </p>
                <ul className="p-xss-0 p-md-3 justified-text pt-0">
                  <li>
                    <p className="mb-0 justified-text">
                      <strong>DNS manual: </strong>permite que os servidores DNS
                      sejam definidos manualmente.
                    </p>
                    <div className="d-flex flex-sm-wrap flex-xss-wrap justify-content-center">
                      <img
                        src="./res/figures/dns-ipv4.png"
                        className="card-img-bottom img-xl"
                        alt=""
                      />
                    </div>
                    <ul className="p-xss-0 p-md-3 justified-text pt-0">
                      <li>
                        <p className="mb-0 justified-text">
                          <strong>Servidor DNS 1: </strong>define o endereço IP
                          do servidor DNS primário.
                        </p>
                      </li>
                      <li>
                        <p className="mb-0 justified-text">
                          <strong>Servidor DNS 2: </strong>define o endereço IP
                          do servidor DNS secundário.
                        </p>
                      </li>
                    </ul>
                  </li>
                  <li>
                    <p className="mb-0 justified-text">
                      <strong>DNS automático: </strong>permite que os servidores
                      DNS sejam definidos automaticamente.
                    </p>
                    <div className="d-flex flex-sm-wrap flex-xss-wrap justify-content-center">
                      <img
                        src="./res/figures/dns-ipv4-automatico.png"
                        className="card-img-bottom img-xl"
                        alt=""
                      />
                    </div>
                  </li>
                </ul>
              </li>
            </ul>

            <p className="mb-0 text-muted">IPv6</p>

            <ul className="p-xss-0 p-md-3 justified-text pt-0">
              <li>
                <p className="mb-0 justified-text">
                  <strong>Modo DNS:</strong>
                </p>
                <ul className="p-xss-0 p-md-3 justified-text pt-0">
                  <li>
                    <p className="mb-0 justified-text">
                      <strong>DNS manual: </strong>permite que os servidores DNS
                      sejam definidos manualmente.
                    </p>
                    <div className="d-flex flex-sm-wrap flex-xss-wrap justify-content-center">
                      <img
                        src="./res/figures/dns-ipv6.png"
                        className="card-img-bottom img-xl"
                        alt=""
                      />
                    </div>
                    <ul className="p-xss-0 p-md-3 justified-text pt-0">
                      <li>
                        <p className="mb-0 justified-text">
                          <strong>Servidor DNS 1: </strong>define o endereço IP
                          do servidor DNS primário.
                        </p>
                      </li>
                      <li>
                        <p className="mb-0 justified-text">
                          <strong>Servidor DNS 2: </strong>define o endereço IP
                          do servidor DNS secundário.
                        </p>
                      </li>
                    </ul>
                  </li>
                  <li>
                    <p className="mb-0 justified-text">
                      <strong>DNS automático: </strong>permite que os servidores
                      DNS sejam definidos automaticamente.
                    </p>
                    <div className="d-flex flex-sm-wrap flex-xss-wrap justify-content-center">
                      <img
                        src="./res/figures/dns-ipv6-automatico.png"
                        className="card-img-bottom img-xl"
                        alt=""
                      />
                    </div>
                  </li>
                </ul>
              </li>
            </ul>
          </div>

          <div>
            <div id="captive-portal" className="fw-bold">
              Captive Portal
            </div>
            <p className="justified-text">
              Configuração de autenticação externa de usuários na rede.
            </p>

            <div className="d-flex justify-content-center">
              <img
                src="./res/figures/captive-portal.png"
                className="card-img-bottom img-xl"
                alt=""
              />
            </div>

            <br />

            <ul className="p-xss-0 p-md-3 justified-text pt-0">
              <li>
                <p className="mb-0 justified-text">
                  <strong>Habilitar Captive Portal: </strong>selecione as redes
                  Wi-Fi que utilizarão a função Captive Portal.
                </p>
              </li>
              <li>
                <p className="mb-0 justified-text">
                  <strong>
                    Endereço do Captive Portal Externo (autenticador):{" "}
                  </strong>
                  endereço da página externa na qual o usuário será
                  redirecionado para autenticação.
                </p>
              </li>
              <li>
                <p className="mb-0 justified-text">
                  <strong>Tempo de sessão: </strong>tempo de sessão do usuário.
                  Ao expirar o tempo configurado, a sessão será encerrada e o
                  usuário precisará se re-autenticar. O tempo de sessão
                  informado acima só será aplicado quando um intervalo válido
                  não for definido pelo servidor. Pode ser definido em minutos,
                  horas ou dias.
                </p>
              </li>
              <li>
                <p className="mb-0 justified-text">
                  <strong>Tempo de inatividade: </strong>ao ser detectada a
                  inatividade do usuário no limite configurado, o mesmo terá sua
                  sessão encerrada. Pode ser definido em minutos, horas ou dias.
                </p>
              </li>
              <li>
                <p className="mb-0 justified-text">
                  <strong>Tipo de autenticação: </strong>Externo ou Radius.
                </p>
                <ul className="p-xss-0 p-md-3 justified-text pt-0">
                  <li>
                    <p className="mb-0 justified-text">
                      <strong>Externo: </strong>permite definir a senha
                      utilizada pelo AP para autenticar-se no servidor captive
                      portal externo.
                    </p>
                  </li>
                  <li>
                    <p className="mb-0 justified-text">
                      <strong>Radius: </strong>permite definir qual dos
                      servidores Radius cadastrados deve ser usado para
                      autenticação.
                    </p>
                    <div className="d-flex justify-content-center">
                      <img
                        src="./res/figures/auth-servidor-radius-captive.png"
                        className="card-img-bottom img-xl"
                        alt=""
                      />
                    </div>
                  </li>
                </ul>
              </li>
              <li>
                <p className="mb-0 justified-text">
                  <strong>Walled Garden</strong>
                </p>
                <p className="justified-text">
                  O Zeus OS permite adicionar outros domínios para acesso antes
                  de se autenticar ao Captive Portal Externo através do Walled
                  Garden. Se necessário acessar outro domínio antes da
                  autenticação, é necessário adicionar nessa opção.
                </p>
                <div className="d-flex justify-content-center">
                  <img
                    src="./res/figures/walled-garden.png"
                    className="card-img-bottom img-xl"
                    alt=""
                  />
                </div>
              </li>
            </ul>
          </div>

          <div>
            <div id="qos" className="fw-bold">
              QOS
            </div>

            <p className="mb-0 justified-text">
              Utilize a opção QoS para limitar/garantir a banda por SSID ou para
              limitar a banda por IP/MAC.
            </p>
            <br />

            <div className="d-flex justify-content-center">
              <img
                src="./res/figures/qos.png"
                className="card-img-bottom img-xl"
                alt="QOS"
              />
            </div>
            <br />

            <div className="p-xss-0 p-md-3 justified-text pt-0">
              <p className="mb-0">
                <strong>Link da internet</strong>
              </p>
              <div className="d-flex justify-content-center">
                <img
                  src="./res/figures/qos-link-internet.png"
                  className="card-img-bottom img-xl"
                  alt="Link da internet"
                />
              </div>
              <ul>
                <li>
                  <p className="mb-0 justified-text">
                    <strong>Upload (Mbps): </strong>Informe a velocidade real de
                    upload do link de internet (para fins de cálculo
                    percentual).
                  </p>
                </li>
                <li>
                  <p className="mb-0 justified-text">
                    <strong>Download (Mbps): </strong>Informe a velocidade real
                    de download do link de internet (para fins de cálculo
                    percentual).
                  </p>
                  <p className="mb-0 justified-text text-muted">
                    <strong>Obs.: </strong>A taxa de transferência máxima do
                    produto pode ser afetada ao ativar a função QoS.
                  </p>
                </li>
              </ul>
            </div>

            <div className="p-xss-0 p-md-3 justified-text pt-0">
              <p className="mb-0">
                <strong>Limite de banda por IP/MAC</strong>
              </p>
              <p className="justified-text">
                <strong>Obs.: </strong>A funcionalidade Limite de Banda por
                IP/MAC está disponível apenas em modo Roteador.
              </p>
              <div className="d-flex justify-content-center">
                <img
                  src="./res/figures/qos-limite-mac.png"
                  className="card-img-bottom img-xl"
                  alt="Limite de banda por IP/MAC"
                />
              </div>
              <ul>
                <li>
                  <p className="mb-0 justified-text">
                    <strong>Habilitado: </strong>Selecione para habilitar a
                    opção de limite de banda.
                  </p>
                </li>
                <li>
                  <p className="mb-0 justified-text">
                    <strong>Descrição: </strong>Descrição da limitação.
                  </p>
                </li>
                <li>
                  <p className="mb-0 justified-text">
                    <strong>Rede/IP: </strong>Rede/IP cuja banda deseja limitar.
                  </p>
                </li>
                <li>
                  <p className="mb-0 justified-text">
                    <strong>MAC: </strong>Endereço MAC do equipamento.
                  </p>
                </li>
                <li>
                  <p className="mb-0 justified-text">
                    <strong>Upload (Mbps): </strong>Informe o valor em Mbps,
                    para limitar banda de upload, para o SSID correspondente.
                  </p>
                </li>
                <li>
                  <p className="mb-0 justified-text">
                    <strong>Download (Mbps): </strong>Informe o valor em Mbps,
                    para limitar banda de download, para o SSID correspondente.
                  </p>
                </li>
              </ul>
            </div>

            <div className="p-xss-0 p-md-3 justified-text pt-0">
              <p className="mb-0">
                <strong>Limite de banda por SSID</strong>
              </p>
              <div className="d-flex justify-content-center">
                <img
                  src="./res/figures/qos-limite-ssid.png"
                  className="card-img-bottom img-xl"
                  alt="Limite de banda por SSID"
                />
              </div>
              <ul>
                <li>
                  <p className="mb-0 justified-text">
                    <strong>Habilitado: </strong>Selecione para habilitar a
                    opção de limite de banda.
                  </p>
                </li>
                <li>
                  <p className="mb-0 justified-text">
                    <strong>SSID: </strong>SSID da rede.
                  </p>
                </li>
                <li>
                  <p className="mb-0 justified-text">
                    <strong>Frequência: </strong>Em qual/quais frequências o
                    SSID está atuando na rede.
                  </p>
                </li>
                <li>
                  <p className="mb-0 justified-text">
                    <strong>Upload (Mbps): </strong>Informe o valor em Mbps,
                    para limitar banda de upload, para o SSID correspondente.
                  </p>
                </li>
                <li>
                  <p className="mb-0 justified-text">
                    <strong>Download (Mbps): </strong>Informe o valor em Mbps,
                    para limitar banda de download, para o SSID correspondente.
                  </p>
                </li>
              </ul>
            </div>

            <div className="p-xss-0 p-md-3 justified-text pt-0">
              <p className="mb-0">
                <strong>Garantia de banda por SSID</strong>
              </p>
              <div className="d-flex justify-content-center">
                <img
                  src="./res/figures/qos-garantia-ssid.png"
                  className="card-img-bottom img-lg img-xl"
                  alt="Garantia de banda por SSID"
                />
              </div>
              <ul>
                <li>
                  <p className="mb-0 justified-text">
                    <strong>Habilitado: </strong>Marque para ativar o controle
                    de garantia de banda.
                  </p>
                </li>
                <li>
                  <p className="mb-0 justified-text">
                    <strong>SSID: </strong>SSID da rede.
                  </p>
                </li>
                <li>
                  <p className="mb-0 justified-text">
                    <strong>Frequência: </strong>Em qual/quais frequências o
                    SSID está atuando na rede.
                  </p>
                </li>
                <li>
                  <p className="mb-0 justified-text">
                    <strong>Upload (Mbps): </strong>Porcentagem de banda de
                    upload configurada no link da internet, garantida para a
                    rede sem fio selecionada.
                    <br />O cálculo da porcentagem não pode resultar em valor
                    menor que 0,001Mbps.
                    <br />
                    Para redes “Dual band”, o valor da porcentagem é dividido
                    entre as duas frequências (2.4GHz e 5Ghz).
                  </p>
                </li>
                <li>
                  <p className="mb-0 justified-text">
                    <strong>Download (Mbps): </strong>Porcentagem de banda de
                    upload configurada no link da internet, garantida para a
                    rede sem fio selecionada.
                    <br />O cálculo da porcentagem não pode resultar em valor
                    menor que 0,001Mbps.
                    <br />
                    Para redes “Dual band”, o valor da porcentagem é dividido
                    entre as duas frequências (2.4GHz e 5Ghz).
                  </p>
                </li>
              </ul>
              <p>
                <strong>Obs.: </strong>
                <i>
                  É recomendado não aplicar mais de 256 regras para limite de
                  banda.
                </i>
              </p>
            </div>
          </div>

          <div>
            <div id="rotas" className="fw-bold">
              Rotas
            </div>
            <p className="mb-0 justified-text">
              Permite criar ou excluir rotas na tabela de roteamento do
              equipamento.
            </p>
            <p className="justified-text">
              <strong>Obs.: </strong>Essa funcionalidade está disponível apenas
              quando o modo de operação for Roteador.
            </p>

            <div className="d-flex justify-content-center img-container">
              <img
                src="./res/figures/rotas.png"
                className="card-img-bottom img-xl"
                alt=""
              />
            </div>

            <ul className="p-xss-0 p-md-3 justified-text pt-0">
              <li>
                <p className="mb-0 justified-text">
                  <strong>Descrição: </strong>Insira uma descrição para a rota a
                  ser criada.
                </p>
              </li>
              <li>
                <p className="mb-0 justified-text">
                  <strong>Rede de destino: </strong>Define a rede
                  destino/máscara.
                </p>
              </li>
              <li>
                <p className="mb-0 justified-text">
                  <strong>Máscara de Sub-Rede: </strong>Máscara de sub-rede do
                  equipamento para a rota específica.
                </p>
              </li>
              <li>
                <p className="mb-0 justified-text">
                  <strong>Gateway: </strong>Define o gateway-padrão de destino
                  para essa rota.
                </p>
              </li>
            </ul>

            <p className="justified-text">
              Use o botão{" "}
              <i className="fa fa-plus-circle" aria-hidden="true"></i> Adicionar
              para criar as rotas e preencher a tabela de roteamento, ou use o
              botão <i className="fa fa-trash" aria-hidden="true"></i> para
              excluir uma rota.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Network;
